import { t } from 'i18next';

import { Field } from './field';
import useCurrentCountry from 'hooks/useCurrentCountry';
import { AC } from 'settings/form';
import { genderOptions, genderOptionsUk } from 'model/CommonFields';
import { yesNoOptions } from 'model/NewsletterFormFields';

const { isUk } = useCurrentCountry();

export const newsletterFormFields: Record<string, Field> = {
  email: {
    label: t('LABEL_EMAIL_ADDRESS'),
    name: 'email',
    required: true,
    autoComplete: AC.Email,
  },
  civility: {
    label: t('LABEL_TITLE_GENDER'),
    name: 'civility',
    type: 'radio',
    options: isUk ? genderOptionsUk : genderOptions,
    required: true,
    autoComplete: AC.HonorificPrefix,
  },
  lastName: {
    label: t('LABEL_SURNAME'),
    name: 'lastName',
    required: true,
    autoComplete: AC.LastName,
  },
  firstName: {
    label: t('LABEL_FIRST_NAME'),
    name: 'firstName',
    required: true,
    autoComplete: AC.FirstName,
  },
  cellPhone: {
    label: t('LABEL_PHONE_NUMBER'),
    name: 'cellPhone',
    autoComplete: AC.Off,
    validation: 'number',
  },
  dateOfBirth: {
    label: t('LABEL_DATE_OF_BIRTH'),
    name: 'dateOfBirth',
    type: 'date',
    autoComplete: {
      day: AC.BirthDay,
      month: AC.BirthMonth,
      year: AC.BirthYear,
    },
  },
};

export const newsletterSubOptionsFormFields: Record<string, Field> = {
  smsOption: {
    label: t('LABEL_NEWSLETTER_AFIBEL_SMS'),
    name: 'smsOption',
    type: 'radio',
    options: yesNoOptions,
    required: true,
  },
  partOption: {
    label: t('LABEL_NEWSLETTER_PARTNER_EMAIL'),
    name: 'partOption',
    type: 'radio',
    options: yesNoOptions,
    required: true,
  },
};
